import React from 'react';
import PropTypes from 'prop-types';
import {Field, reduxForm} from 'redux-form';
import RaisedButton from 'material-ui/RaisedButton';
import style from '../../../styles/styles';
import {Avatar, Chip} from "material-ui";
import { renderTextField, renderSuperSelectField, renderNumberField } from '../../../services/form';
import withTranslation from "../../../hoc/withTranslation";
import i18n from "i18next";

const validate = values => {
    const errors = {};
    const numberFields = [
        'order'
    ];

    numberFields.forEach(field => {
        const value = values[field];
        if (isNaN(Number(value))) {
            errors[field] = i18n.t('generic.error_form_number');
        }
    });

    return errors;
};

export class MediaForm extends React.Component {

    static propTypes = {
        types: PropTypes.arrayOf(PropTypes.object),
        onFormReset: PropTypes.func
    };
    static defaultProps = {
        mediaTypes: []
    };

    // Render

    renderMediaTypesSelection = (mediaTypes, hintText) => {
        if (!mediaTypes || mediaTypes.length === 0) {
            return hintText;
        }

        return (
            <div style={style.chip.wrapper}>
                {mediaTypes.map(({value, label}, index) => {

                    let mediaType = this.props.mediaTypes.find((type) => {
                        return type.id === value;
                    });

                    if (mediaType) {
                        return (
                            <Chip key={value} style={style.chip.margin}>
                                <Avatar
                                    icon={mediaType.picture &&
                                    <img src={mediaType.picture} alt=""
                                         style={style.image.contain} />}
                                    size={20}
                                    backgroundColor={mediaType.color}
                                    style={{ overflow: 'hidden' }}
                                />
                                {mediaType.name}
                            </Chip>
                        )
                    } else {
                        return hintText
                    }
                })}
            </div>
        );
    };

    render() {
        const {handleSubmit, pristine, reset, submitting} = this.props;


        return (
            <form onSubmit={handleSubmit}>
                <div>
                    <Field
                        id="name"
                        name="name"
                        component={renderTextField}
                        label={this.props.t('generic.name')}
                        fullWidth={true}
                    />
                    <Field
                        id="order"
                        name="order"
                        component={renderNumberField}
                        label={this.props.t('generic.order')}
                        fullWidth={true}
                    />
                    <Field
                        id="media_types_id"
                        name="media_types_id"
                        label={this.props.t('generic.types')}
                        style={{marginTop: 30}}
                        component={renderSuperSelectField}
                        fullWidth={true}
                        selectionsRenderer={this.renderMediaTypesSelection}
                        normalize={values => {
                            if (!values) {
                                return []
                            }

                            return values.map(({value, label}) => {
                                return value;
                            });
                        }}
                        format={values => {
                            if (!values) {
                                return []
                            }

                            return values.map(mediaTypeId => {
                                const mediaType = this.props.mediaTypes.find(mediaType => mediaType.id === mediaTypeId);
                                return {
                                    value: mediaTypeId,
                                    label: mediaType ? mediaType.name : mediaTypeId
                                };
                            });
                        }}
                    >
                        {this.props.mediaTypes.map((mediaType) => (
                            <div key={mediaType.id} value={mediaType.id} label={mediaType.name}>
                                <Avatar
                                    style={style.margin.right.small}
                                    icon={mediaType.picture &&
                                    <img src={mediaType.picture} alt=""
                                         style={style.image.contain} />}
                                    size={20}
                                    backgroundColor={mediaType.color}
                                />
                                {mediaType.name}
                            </div>
                        ))}
                    </Field>
                    <Field
                        id="tag"
                        name="tag"
                        component={renderTextField}
                        label={this.props.t('generic.tag')}
                        fullWidth={true}
                    />
                </div>
                <div style={style.formButtons}>
                    <RaisedButton
                        style={style.formButton}
                        label={this.props.t('generic.save')}
                        disabled={pristine || submitting}
                        type="submit"
                        primary={true}
                    />
                    <RaisedButton
                        style={style.formButton}
                        label={this.props.t('generic.reset')}
                        type="button"
                        disabled={pristine || submitting}
                        onClick={() => {
                            reset();
                            if (this.props.onFormReset) {
                                this.props.onFormReset();
                            }
                        }}
                    />
                </div>
            </form>
        );
    }
}

export default reduxForm({
    form: 'editMedia',
    validate
})(withTranslation(MediaForm));



// WEBPACK FOOTER //
// src/components/media/MediaForm/MediaForm.js